// trigramData.js

import TRI1 from '@/assets/trigrams/trigram_1.png' // 天
import TRI2 from '@/assets/trigrams/trigram_2.png' // 澤
import TRI3 from '@/assets/trigrams/trigram_3.png' // 火
import TRI4 from '@/assets/trigrams/trigram_4.png' // 雷
import TRI5 from '@/assets/trigrams/trigram_5.png' // 風
import TRI6 from '@/assets/trigrams/trigram_6.png' // 水
import TRI7 from '@/assets/trigrams/trigram_7.png' // 山
import TRI8 from '@/assets/trigrams/trigram_8.png' // 地

export const trigrams = [
  {
    index: 0,
    name: '건(乾)',
    fullName: '중천건(重天乾)',
    ha: TRI1,
    sang: TRI1,
  },
  {
    index: 1,
    name: '곤(坤)',
    fullName: '중지곤(重地坤)',
    ha: TRI8,
    sang: TRI8,
  },
  {
    index: 2,
    name: '둔(屯)',
    fullName: '수뢰둔(水雷屯)',
    ha: TRI4,
    sang: TRI6,
  },
  {
    index: 3,
    name: '몽(蒙)',
    fullName: '산수몽(山水蒙)',
    ha: TRI6,
    sang: TRI7,
  },
  {
    index: 4,
    name: '수(需)',
    fullName: '수천수(水天需)',
    ha: TRI1,
    sang: TRI6,
  },
  {
    index: 5,
    name: '송(訟)',
    fullName: '천수송(天水訟)',
    ha: TRI6,
    sang: TRI1,
  },
  {
    index: 6,
    name: '사(師)',
    fullName: '지수사(地水師)',
    ha: TRI6,
    sang: TRI8,
  },
  {
    index: 7,
    name: '비(比)',
    fullName: '수지비(水地比)',
    ha: TRI8,
    sang: TRI6,
  },
  {
    index: 8,
    name: '소축(小畜)',
    fullName: '풍천소축(風天小畜)',
    ha: TRI1,
    sang: TRI5,
  },
  {
    index: 9,
    name: '리(履)',
    fullName: '천택리(天澤履)',
    ha: TRI2,
    sang: TRI1,
  },
  {
    index: 10,
    name: '태(泰)',
    fullName: '지천태(地天泰)',
    ha: TRI1,
    sang: TRI8,
  },
  {
    index: 11,
    name: '비(否)',
    fullName: '천지비(天地否)',
    ha: TRI8,
    sang: TRI1,
  },
  {
    index: 12,
    name: '동인(同人)',
    fullName: '천화동인(天火同人)',
    ha: TRI3,
    sang: TRI1,
  },
  {
    index: 13,
    name: '대유(大有)',
    fullName: '화천대유(火天大有)',
    ha: TRI1,
    sang: TRI3,
  },
  {
    index: 14,
    name: '겸(謙)',
    fullName: '지산겸(地山謙)',
    ha: TRI7,
    sang: TRI8,
  },
  {
    index: 15,
    name: '예(豫)',
    fullName: '뇌지예(雷地豫)',
    ha: TRI8,
    sang: TRI4,
  },
  {
    index: 16,
    name: '수(隨)',
    fullName: '택뢰수(澤雷隨)',
    ha: TRI4,
    sang: TRI2,
  },
  {
    index: 17,
    name: '고(蠱)',
    fullName: '산풍고(山風蠱)',
    ha: TRI5,
    sang: TRI7,
  },
  {
    index: 18,
    name: '임(臨)',
    fullName: '지택임(地澤臨)',
    ha: TRI2,
    sang: TRI8,
  },
  {
    index: 19,
    name: '관(觀)',
    fullName: '풍지관(風地觀)',
    ha: TRI8,
    sang: TRI5,
  },
  {
    index: 20,
    name: '서합(噬嗑)',
    fullName: '화뢰서합(火雷噬嗑)',
    ha: TRI4,
    sang: TRI3,
  },
  {
    index: 21,
    name: '분(賁)',
    fullName: '산화분(山火賁)',
    ha: TRI3,
    sang: TRI7,
  },
  {
    index: 22,
    name: '박(剝)',
    fullName: '산지박(山地剝)',
    ha: TRI8,
    sang: TRI7,
  },
  {
    index: 23,
    name: '복(復)',
    fullName: '지뢰복(地雷復)',
    ha: TRI4,
    sang: TRI8,
  },
  {
    index: 24,
    name: '무망(无妄)',
    fullName: '천뢰무망(天雷无妄)',
    ha: TRI4,
    sang: TRI1,
  },
  {
    index: 25,
    name: '대축(大畜)',
    fullName: '산천대축(山天大畜)',
    ha: TRI1,
    sang: TRI7,
  },
  {
    index: 26,
    name: '이(頤)',
    fullName: '산뢰이(山雷頤)',
    ha: TRI4,
    sang: TRI7,
  },
  {
    index: 27,
    name: '대과(大過)',
    fullName: '택풍대과(澤風大過)',
    ha: TRI5,
    sang: TRI2,
  },
  {
    index: 28,
    name: '감(坎)',
    fullName: '중수감(重水坎)',
    ha: TRI6,
    sang: TRI6,
  },
  {
    index: 29,
    name: '리(離)',
    fullName: '중화리(重火離)',
    ha: TRI3,
    sang: TRI3,
  },
  {
    index: 30,
    name: '함(咸)',
    fullName: '택산함(澤山咸)',
    ha: TRI7,
    sang: TRI2,
  },
  {
    index: 31,
    name: '항(恒)',
    fullName: '뇌풍항(雷風恒)',
    ha: TRI5,
    sang: TRI4,
  },
  {
    index: 32,
    name: '둔(遯)',
    fullName: '천산둔(天山遯)',
    ha: TRI7,
    sang: TRI1,
  },
  {
    index: 33,
    name: '대장(大壯)',
    fullName: '뇌천대장(雷天大壯)',
    ha: TRI1,
    sang: TRI4,
  },
  {
    index: 34,
    name: '진(晉)',
    fullName: '화지진(火地晉)',
    ha: TRI8,
    sang: TRI3,
  },
  {
    index: 35,
    name: '명이(明夷)',
    fullName: '지화명이(地火明夷)',
    ha: TRI3,
    sang: TRI8,
  },
  {
    index: 36,
    name: '가인(家人)',
    fullName: '풍화가인(風火家人)',
    ha: TRI3,
    sang: TRI5,
  },
  {
    index: 37,
    name: '규(睽)',
    fullName: '화택규(火澤睽)',
    ha: TRI2,
    sang: TRI3,
  },
  {
    index: 38,
    name: '건(蹇)',
    fullName: '수산건(水山蹇)',
    ha: TRI7,
    sang: TRI6,
  },
  {
    index: 39,
    name: '해(解)',
    fullName: '뇌수해(雷水解)',
    ha: TRI6,
    sang: TRI4,
  },
  {
    index: 40,
    name: '손(損)',
    fullName: '산택손(山澤損)',
    ha: TRI2,
    sang: TRI7,
  },
  {
    index: 41,
    name: '익(益)',
    fullName: '풍뢰익(風雷益)',
    ha: TRI4,
    sang: TRI5,
  },
  {
    index: 42,
    name: '쾌(夬)',
    fullName: '택천쾌(澤天夬)',
    ha: TRI1,
    sang: TRI2,
  },
  {
    index: 43,
    name: '구(姤)',
    fullName: '천풍구(天風姤)',
    ha: TRI5,
    sang: TRI1,
  },
  {
    index: 44,
    name: '췌(萃)',
    fullName: '택지췌(澤地萃)',
    ha: TRI8,
    sang: TRI2,
  },
  {
    index: 45,
    name: '승(升)',
    fullName: '지풍승(地風升)',
    ha: TRI5,
    sang: TRI8,
  },
  {
    index: 46,
    name: '곤(困)',
    fullName: '택수곤(澤水困)',
    ha: TRI6,
    sang: TRI2,
  },
  {
    index: 47,
    name: '정(井)',
    fullName: '수풍정(水風井)',
    ha: TRI5,
    sang: TRI6,
  },
  {
    index: 48,
    name: '혁(革)',
    fullName: '택화혁(澤火革)',
    ha: TRI3,
    sang: TRI2,
  },
  {
    index: 49,
    name: '정(鼎)',
    fullName: '화풍정(火風鼎)',
    ha: TRI5,
    sang: TRI3,
  },
  {
    index: 50,
    name: '진(震)',
    fullName: '중뢰진(重雷震)',
    ha: TRI4,
    sang: TRI4,
  },
  {
    index: 51,
    name: '간(艮)',
    fullName: '중산간(重山艮)',
    ha: TRI7,
    sang: TRI7,
  },
  {
    index: 52,
    name: '점(漸)',
    fullName: '풍산점(風山漸)',
    ha: TRI7,
    sang: TRI5,
  },
  {
    index: 53,
    name: '귀매(歸妹)',
    fullName: '뇌택귀매(雷澤歸妹)',
    ha: TRI2,
    sang: TRI4,
  },
  {
    index: 54,
    name: '풍(豐)',
    fullName: '뇌화풍(雷火豐)',
    ha: TRI3,
    sang: TRI4,
  },
  {
    index: 55,
    name: '려(旅)',
    fullName: '화산려(火山旅)',
    ha: TRI7,
    sang: TRI3,
  },
  {
    index: 56,
    name: '손(巽)',
    fullName: '중풍손(重風巽)',
    ha: TRI5,
    sang: TRI5,
  },
  {
    index: 57,
    name: '태(兌)',
    fullName: '중택태(重澤兌)',
    ha: TRI2,
    sang: TRI2,
  },
  {
    index: 58,
    name: '환(渙)',
    fullName: '풍수환(風水渙)',
    ha: TRI6,
    sang: TRI5,
  },
  {
    index: 59,
    name: '절(節)',
    fullName: '수택절(水澤節)',
    ha: TRI2,
    sang: TRI6,
  },
  {
    index: 60,
    name: '중부(中孚)',
    fullName: '풍택중부(風澤中孚)',
    ha: TRI2,
    sang: TRI5,
  },
  {
    index: 61,
    name: '소과(小過)',
    fullName: '뇌산소과(雷山小過)',
    ha: TRI7,
    sang: TRI4,
  },
  {
    index: 62,
    name: '기제(旣濟)',
    fullName: '수화기제(水火旣濟)',
    ha: TRI3,
    sang: TRI6,
  },
  {
    index: 63,
    name: '미제(未濟)',
    fullName: '화수미제(火水未濟)',
    ha: TRI6,
    sang: TRI3,
  },
]
